import { Skeleton, useToast } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { Typography } from '~/packages/common-frontend/components/Typography';
import { errorToastConfig } from '~/packages/common-frontend/constants';
import { getUnexpectedErrorMessage } from '~/packages/common-frontend/utils';
import { useCreditFacilityContext } from '~/packages/credit-facility/hooks/CreditFacilityProvider';
import { PortfolioStatementsExpensesFeesChart } from '~/packages/portfolio/ui/statements/PortfolioStatementsExpensesFeesChart';
import { useGetLedgerAccountsQuery } from '~/packages/statements/requests/ledger.gql.generated';

export const InsightsExpensesFeesContainerV2 = () => {
  const toast = useToast();
  const { creditFacilityId } = useCreditFacilityContext();

  const {
    data: ledgerAccountsData,
    loading: isLedgerAccountsLoading,
  } = useGetLedgerAccountsQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = getUnexpectedErrorMessage(err);
      toast(errorToastConfig);
    },
    variables: {
      creditFacilityId,
      ledgerAccountGroup: 'expensesFees',
    },
  });

  if (!ledgerAccountsData || isLedgerAccountsLoading) {
    return <Skeleton data-testid="loading-insights-view" height="600px" />;
  }

  const countersignerOrganizationIds = _.map(
    ledgerAccountsData.ledgerAccounts,
    (account) => account.organizationId,
  );
  return (
    <>
      <Typography variant="section-title">Expenses &amp; Fees</Typography>
      <PortfolioStatementsExpensesFeesChart
        accounts={ledgerAccountsData.ledgerAccounts}
        creditFacilityId={creditFacilityId}
        organizationIds={countersignerOrganizationIds}
        chartTitle="Expenses & Fees"
      />
    </>
  );
};
